import { createContext } from 'react';

const PageDataContext = createContext<{ reload?: () => void }>({});

export default PageDataContext;
